import { render } from "./TabWrapperComponent.vue?vue&type=template&id=50914c76"
import script from "./TabWrapperComponent.vue?vue&type=script&lang=js"
export * from "./TabWrapperComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__